import { useCallback } from 'react';
import { TValidationMethod } from 'js/utils/Validation/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from './helpers';
import { useGetFormFieldValue } from '../../../../hooks';
import { useWithRecordLevelValidation } from '../useWithRecordLevelValidation';

export const usePolandIdFieldValidation = ({ fieldName }: { fieldName: string }) => {
    const translate = useComponentTranslations();
    const getFormFieldValue = useGetFormFieldValue();
    const withRecordLevelValidation = useWithRecordLevelValidation({ fieldName });

    const polandIdValidate = useCallback<TValidationMethod<string>>(async (value) => {
        const errorMessage = 'playtech.mobile.system.form.polandID.internal.invalidPESEL';

        if (!/^\d{11}$/.test(value)) {
            return translate(errorMessage);
        }

        const birthdate = getFormFieldValue('birthdate');
        const sex = getFormFieldValue('sex');

        if (!birthdate || !sex) {
            return translate(errorMessage);
        }

        const [RR, MM, DD, PPPP, K] = value
            .split(/(\w{2})(\w{2})(\w{2})(\w{4})(\w)/)
            .filter((part) => part !== '')
            .map((part) => Number(part));

        const isBirthDateValid = helpers.getIsBirthdateValid({ RR, MM, DD }, birthdate);
        const isGenderValid = sex === 'M' ? PPPP % 2 === 1 : PPPP % 2 === 0;
        const isChecksumValid = helpers.getIsChecksumValid(value, K);

        if (!(isBirthDateValid && isGenderValid && isChecksumValid)) {
            return errorMessage;
        }
    }, [getFormFieldValue, translate]);

    return withRecordLevelValidation(polandIdValidate);
};
